import React from 'react';
import { Link } from 'react-router-dom';
import MultilineText from './MultilineText';
import { HEX_POINTS } from './HexMark';
import { HERO_FACTS } from '../data/hero';
import layout from '../styles/layout.module.css';
import styles from './HeroSection.module.css';

const HeroSection: React.FC = () => {
  return (
    <section id="hero" className={styles.hero} aria-labelledby="hero-title">
      <div className={`${layout.wrap} ${styles.grid}`}>
        <div className={styles.copy}>
          <p className={styles.eyebrow}>
            AWS 設計・構築・移行 ／ 再販・請求代行 ／ CI/CD ／ AI 開発ツール導入
            ── 金沢から全国へ
          </p>
          <h1 id="hero-title" className={styles.title}>
            AWSの中にいた目で、
            <br />
            あなたの側に立つ。
          </h1>
          <p className={styles.lead}>
            AWS
            でソリューションアーキテクトとして企業を支援してきた代表が、今はお客様の側で
            AWS を扱います。契約と請求の窓口から、設計・構築・移行、CI/CD や
            Claude Code・Kiro
            の導入まで、金沢から全国へリモートを基本に伴走します。
          </p>
          <div className={styles.actions}>
            <Link to="/contact" className={styles.primaryButton}>
              相談する →
            </Link>
            <a href="#services" className={styles.textLink}>
              サービスを見る
            </a>
          </div>
        </div>

        <div className={styles.aside}>
          {/* ロゴ由来の六角形の線画（装飾） */}
          <svg
            className={styles.hexagon}
            aria-hidden="true"
            focusable="false"
            viewBox="0 0 200 200"
          >
            <polygon
              points={HEX_POINTS}
              fill="none"
              stroke="var(--color-ink)"
              strokeOpacity="0.22"
              strokeWidth="1.2"
              strokeLinejoin="round"
            />
            <circle
              cx="180"
              cy="100"
              r="5"
              fill="var(--color-paper)"
              stroke="var(--color-navy)"
              strokeOpacity="0.6"
              strokeWidth="1.2"
            />
            <circle
              cx="60"
              cy="30.7"
              r="5"
              fill="var(--color-paper)"
              stroke="var(--color-slate)"
              strokeOpacity="0.6"
              strokeWidth="1.2"
            />
            <circle
              cx="60"
              cy="169.3"
              r="5"
              fill="var(--color-paper)"
              stroke="var(--color-navy)"
              strokeOpacity="0.6"
              strokeWidth="1.2"
            />
          </svg>

          <dl className={styles.facts}>
            {HERO_FACTS.map((fact) => (
              <div key={fact.label} className={styles.fact}>
                <dt className={styles.factLabel}>{fact.label}</dt>
                <dd className={styles.factValue}>
                  <MultilineText text={fact.value} />
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
